var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddIcon = function SvgAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81292 9.85909C2.51153 9.90373 2.28027 10.2183 2.28027 10.5321C2.28027 10.8773 2.5601 11.2122 2.90527 11.2122L9.35134 11.2122V17.5484L9.35812 17.6407C9.40276 17.9421 9.71745 18.1734 10.0312 18.1734C10.3764 18.1734 10.7112 17.8936 10.7112 17.5484L10.7112 11.2122L17.0474 11.2121L17.1398 11.2021C17.4412 11.1575 17.6724 10.8459 17.6724 10.5321C17.6724 10.187 17.3926 9.85232 17.0474 9.85232L10.7112 9.85232L10.7112 3.40625L10.7012 3.31389C10.6566 3.01251 10.345 2.78125 10.0312 2.78125C9.68604 2.78125 9.35134 3.06107 9.35134 3.40625V9.85232L2.90527 9.85232L2.81292 9.85909Z",
    fill: "#646EC8"
  })));
};
export default SvgAddIcon;